import {
  AccessDeniedComponent,
  LeaveApplicationComponent,
  LoginComponent,
  SharedLogoutComponent,
} from '@agroone-front/shared'
import { UserPermissions } from '@agroone/entities'
import { Routes } from '@angular/router'
import { AppRoutingEnum } from './app-routing.enum'
import { SingleModuleAccessResolver } from './core/user/single-module-access.resolver'
import { UserGuard } from './core/user/user.guard'
import { TokenRedirectComponent } from './shared/standalone-token-redirect/token-redirect.component'

export const appRoutes: Routes = [
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: AppRoutingEnum.LEAVE_APPLICATION, component: LeaveApplicationComponent },
  {
    path: 'token-redirect',
    component: TokenRedirectComponent,
  },
  { path: 'auth/login', component: LoginComponent },
  { path: AppRoutingEnum.LOGOUT, component: SharedLogoutComponent },
  {
    path: '',
    resolve: [SingleModuleAccessResolver],
    loadChildren: () => import('./scene/hub/hub.routes').then((m) => m.hubRoutes),
  },
  {
    path: AppRoutingEnum.CROP_MANAGEMENT,
    loadChildren: () => import('./scene/crop-management/crop-management.routes').then((m) => m.cropManagementRoutes),
    canActivate: [UserGuard],
    data: {
      permissions: [UserPermissions.CROP_MODULE_ACCESS],
    },
  },
  {
    path: 'user-management',
    loadChildren: () => import('./scene/user-management/user-management.routes').then((m) => m.userManagementRoutes),
    canActivate: [UserGuard],
    data: {
      permissions: [UserPermissions.USER_MODULE_ACCESS],
    },
  },
  { path: '**', redirectTo: '' },
]
